export default __webpack_public_path__ + "static/media/logo_new.3032e4d9.svg";